import { observer } from 'mobx-react-lite';
import React from 'react';
import { AnswerT } from 'src/api/types/AnswerT';
import { cn } from 'src/frames/utils/cn';
import './AnswerListViewItem.scss';

export type PropsT = {
  answer: AnswerT;
  className?: any;
  onClick?: any;
};

export const AnswerListViewItem: React.FC<PropsT> = observer(
  (props: PropsT) => {
    return (
      <div
        className={cn('AnswerListViewItem', 'px-4', props.className)}
        onClick={props.onClick}
      >
        {props.answer.text}
      </div>
    );
  }
);
